import React, { PropsWithChildren, useCallback } from "react";
import { jwtDecode } from "jwt-decode";
import AuthContext from "./AuthContext";

const TOKEN_KEY = "sensify_token";

const AuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const havePermission = useCallback((permission?: string | string[]) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return false;
    try {
      const decoded = jwtDecode<{ permissions?: string[] }>(token);
      const perms = decoded.permissions ?? [];
      if (typeof permission === "string") return perms.includes(permission);
      if (Array.isArray(permission)) return permission.some((p) => perms.includes(p));
    } catch {
      return false;
    }
    return false;
  }, []);

  const haveModule = useCallback((module?: string | string[]) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return false;
    try {
      const decoded = jwtDecode<{ module?: string[] }>(token);
      const modules = decoded.module ?? [];
      if (typeof module === "string") return modules.includes(module);
      if (Array.isArray(module)) return module.some((m) => modules.includes(m));
    } catch {
      return false;
    }
    return false;
  }, []);

  return (
    <AuthContext.Provider value={{ havePermission, haveModule }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
